import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import useDivisions from '~/modules/common/enhancers/useDivisions';
import { useAdditionalOptions } from '~/modules/common/hooks';
import { useOptionsMerge } from '~/modules/common/components/SearchAutocomplete';
import { ScopeObjectType } from '~/types';
import { useStyledGroupLabels } from './hooks';
import GroupDropdown from './GroupDropdown';

export const DivisionDropdown = ({
  classes,
  groupSettings,
  value = '',
  policy,
  onChange,
  enableNoChangeOption = false,
  enableNoValueOption = false,
  scope,
  ...rest
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');
  const { division: divisionLabel } = useStyledGroupLabels();
  const { divisions, loading, hasMore } = useDivisions({
    searchTerm,
    policy,
    scope
  });
  const additionalOptions = useAdditionalOptions({
    enableNoChangeOption,
    enableNoValueOption,
    noValueMessageId: 'dropdownItem.noDivision'
  });

  const noGroupsText = groupSettings.singularName
    ? formatMessage(
        { id: 'groupsDropdown.noGroup' },
        { group: groupSettings.singularName }
      )
    : formatMessage({ id: 'divisionDropdown.noDivision' });

  const options = useOptionsMerge({
    options: divisions,
    additionalOptions
  });

  return (
    <GroupDropdown
      hasMore={hasMore}
      classes={classes}
      setSearchTerm={setSearchTerm}
      options={options}
      label={divisionLabel}
      value={value}
      loading={loading}
      noOptionsText={noGroupsText}
      onChange={onChange}
      optionTypeText={formatMessage({
        id: 'moreOptions.division'
      })}
      {...rest}
    />
  );
};
DivisionDropdown.propTypes = {
  classes: PropTypes.object,
  groupSettings: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
  policy: PropTypes.string,
  enableNoChangeOption: PropTypes.bool,
  enableNoValueOption: PropTypes.bool,
  scope: PropTypes.oneOf(Object.values(ScopeObjectType))
};

export default DivisionDropdown;
